var map = {
	"./adminprofile/add": [
		1950,
		15
	],
	"./agentprofile/add": [
		1951,
		18
	],
	"./ai_assistant/add": [
		1952,
		21
	],
	"./api_key/add": [
		1953,
		24
	],
	"./canned_answer/add": [
		1954,
		29
	],
	"./client/add": [
		1955,
		32
	],
	"./disposition/add": [
		1956,
		37
	],
	"./field/add": [
		1957,
		40
	],
	"./form/add": [
		1958,
		43
	],
	"./form_website/add": [
		1959,
		46
	],
	"./invoice_post/add": [
		1960,
		53
	],
	"./journey/add": [
		1961,
		56
	],
	"./journey_draft/add": [
		1962,
		59
	],
	"./journey_variable/add": [
		1963,
		63
	],
	"./list/add": [
		1964,
		66
	],
	"./list_file/add": [
		1965,
		69
	],
	"./mail_account/add": [
		1966,
		72
	],
	"./operational_hours/add": [
		1967,
		75
	],
	"./organization/add": [
		1968,
		78
	],
	"./pause/add": [
		1969,
		81
	],
	"./phonenumber_monthly_cost/add": [
		1970,
		84
	],
	"./phonenumber_monthly_cost_parent/add": [
		1971,
		87
	],
	"./phonenumber_purchase/add": [
		1972,
		91
	],
	"./phonenumber_setup_cost/add": [
		1973,
		94
	],
	"./phonenumber_setup_cost_parent/add": [
		1974,
		97
	],
	"./prepaid_credit/add": [
		1975,
		104
	],
	"./queue/add": [
		1976,
		107
	],
	"./signature/add": [
		1977,
		111
	],
	"./skill/add": [
		1978,
		114
	],
	"./sla_policy/add": [
		1979,
		117
	],
	"./sound/add": [
		1980,
		120
	],
	"./stats_alarm/add": [
		1981,
		123
	],
	"./stats_custom_metric/add": [
		1982,
		126
	],
	"./stats_report/add": [
		1983,
		129
	],
	"./stats_widget/add": [
		1984,
		132
	],
	"./superadmin_profile/add": [
		1985,
		135
	],
	"./tag/add": [
		1986,
		138
	],
	"./tariff/add": [
		1987,
		141
	],
	"./tariff_parent/add": [
		1988,
		144
	],
	"./team/add": [
		1989,
		147
	],
	"./text_message_source/add": [
		1990,
		9
	],
	"./time_interval/add": [
		1991,
		151
	],
	"./user/add": [
		1992,
		154
	],
	"./voice_asterisk/add": [
		1993,
		157
	],
	"./voice_asterisk_downgrade/add": [
		1994,
		160
	],
	"./voice_route/add": [
		1995,
		167
	],
	"./voice_shortcut/add": [
		1996,
		170
	],
	"./voice_trunk/add": [
		1997,
		173
	],
	"./voice_voicemail/add": [
		1998,
		176
	],
	"./wallboard/add": [
		1999,
		179
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1871;
module.exports = webpackAsyncContext;